const env = window.__ENV__ || {};
const getEnv = (key, fallback) => env[key] || process.env[key] || fallback || "";
export default getEnv;
